import './index.scss';
import React from 'react';
import PropTypes from 'prop-types';
import {DropTarget} from 'react-dnd';
import * as DraggableItemType from 'common/components/dashboard/constants/draggable-item-type';

const dropzoneTarget = {
  drop(props) {
    props.drop();
  },
};

const collectDrop = (connect) => ({
  connectDropTarget: connect.dropTarget(),
});

class DashboardDropzone extends React.Component {
  static propTypes = {
    connectDropTarget: PropTypes.func.isRequired,
    drop: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  setHoverState(hover) {
    this.setState({hover});
  }

  render() {
    const {connectDropTarget} = this.props;
    return connectDropTarget(
      <div
        className={`ContainerCard DashboardDropzone${
          this.state.hover ? ' DashboardDropzone--hover' : ''
        }`}
        key={-1}
        onDragEnter={this.setHoverState.bind(this, true)}
        onDragLeave={this.setHoverState.bind(this, false)}
      />,
    );
  }
}

export default DropTarget(
  DraggableItemType.CARD,
  dropzoneTarget,
  collectDrop,
)(DashboardDropzone);
